import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { STUDIO_LANGUAGES } from '../../../constants';

interface LanguageControlProps {
  locale: string;
  onChangeLocale: (locale: string) => void;
}

const LanguageControl: React.FC<LanguageControlProps> = ({ locale, onChangeLocale }) => (
  <ToggleButtonGroup
    color="primary"
    value={locale}
    exclusive
    fullWidth
    size="small"
    onChange={(_event, value: string | null) => value && onChangeLocale(value)}
  >
    {STUDIO_LANGUAGES.map(language => (
      <ToggleButton key={language.id} value={language.id} className="studio-language-button">
        {language.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default LanguageControl;
